module.exports = __webpack_public_path__ + "img/rf3.0de235e8.png";